module.exports = __webpack_public_path__ + "img/Trupp_Technik_und_Sicherheit.eff62c6d.svg";